<input
  type="text"
  #v
  [attr.name]="fieldKey"
  [value]="value"
  (input)="onInput($event, v.value)"
  (keydown)="onKeyPress($event)"
/>
